import {
  FormControl,
  InputLabel,
  NativeSelect,
  NativeSelectProps,
  OutlinedInput,
} from '@mui/material'
import {useMemo} from 'react'

export interface SelectInputProps extends NativeSelectProps {
  items: SelectInputItem[]
  label?: string
}

export interface SelectInputItem {
  label: string
  value: string
}

export const SelectInput = ({
  fullWidth,
  label,
  items,
  onChange,
  size,
  id,
  value,
  ...selectProps
}: SelectInputProps) => {
  const shrink = useMemo(() => {
    const hasEmptyItem = items.some((item) => item.value === '')
    return hasEmptyItem || !!value
  }, [items, value])

  return (
    <FormControl fullWidth={fullWidth} size={size}>
      {label && (
        <InputLabel shrink={shrink} htmlFor={id}>
          {label}
        </InputLabel>
      )}
      <NativeSelect
        value={value}
        id={id}
        onChange={(e) => onChange?.(e)}
        input={<OutlinedInput label={label} notched={shrink} />}
        {...selectProps}
      >
        {items.map((item, i) => (
          <option
            key={`${item.value} ${item.label}`}
            id={id && `${id}-option-${i}`}
            value={item.value}
          >
            {item.label}
          </option>
        ))}
      </NativeSelect>
    </FormControl>
  )
}
